import React from 'react';

import {
    BloqueHorario,
    construirBloquesHorarios,
    TablaDeCursos,
} from 'src/componentes/tablasDeCursos';
import PanelDeCambios, { Props } from './componentes/PanelDeCambios';
import Curso from './componentes/TablaDeCursos';

type State = Readonly<{
    bloquesHorarios: readonly BloqueHorario[];
}>;

class CambiosDeCurso extends React.Component<Props, State> {
    public readonly state: State = {
        bloquesHorarios: construirBloquesHorarios(this.props.cursos, curso => (
            <Curso key={curso.id} {...curso} />
        )),
    };

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.cursos !== this.props.cursos) {
            this.setState({
                bloquesHorarios: construirBloquesHorarios(this.props.cursos, curso => (
                    <Curso key={curso.id} {...curso} />
                )),
            });
        }
    }

    public render() {
        return (
            <>
                <PanelDeCambios {...this.props} />
                <TablaDeCursos bloquesHorarios={this.state.bloquesHorarios} />
            </>
        );
    }
}

export default CambiosDeCurso;
export { Props };



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/CambiosDeCurso/index.tsx